const theme = {
  light_theme: "Light",
  dark_theme: "Dark",
  default_theme: "System Default",
};

export default theme;
